var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DropFile,{attrs:{"accept":_setup.props.accept,"multiple":_setup.props.multiple},on:{"updateFiles":(inputFile) => _setup.changeHandler(inputFile)}})
}
var staticRenderFns = []

export { render, staticRenderFns }